<template>
  <Title :text="contactsLabel" />
  <div v-if="phoneNumber" class="contact-line">
    <img src="@/assets/phone.svg" />
    <Paragraph class="contact" :text="phoneNumber" />
  </div>
  <div v-if="email" class="contact-line">
    <img src="@/assets/email.svg" />
    <Paragraph class="contact" :text="email" />
  </div>
   <a v-if="linkedIn"  :href="`https://www.linkedin.com/in/${linkedIn}`" target="_blank">
  <div class="contact-line">
      <img src="@/assets/linkedin.svg" />
      <Paragraph class="contact" :text="linkedIn" />
  </div>
  </a> 
  <a v-if="github"  :href="`https://www.github.com/${github}`" target="_blank">
  <div class="contact-line">
      <img width="25" src="@/assets/github.svg" />
      <Paragraph class="contact" :text="`@${github}`" />
  </div>
  </a> 
  <a v-if="gitlab"  :href="`https://www.gitlab.com/${gitlab}`" target="_blank">
  <div class="contact-line">
      <img width="25" src="@/assets/gitlab.svg" />
      <Paragraph class="contact" :text="`@${gitlab}`" />
  </div>
  </a> 

</template>

<script>
import Title from "@/components/Title.vue";
import Paragraph from "@/components/Paragraph.vue";

export default {
  name: "Contacts",

  components: { Title, Paragraph },

  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },

    contactsLabel() {
      return this.currentLanguage.resumeLabels.contacts;
    },

    contacts() {
      return this.currentLanguage.data.contacts;
    },

    phoneNumber() {
      return this.contacts.phone;
    },

    email() {
      return this.contacts.email;
    },

    linkedIn() {
      return this.contacts.linkedIn;
    },
    github() {
      return this.contacts.github;
    },
     gitlab() {
      return this.contacts.gitlab;
    },
    
  },
};
</script>

<style scoped>
.contact-line {
  display: flex;
  margin: 0 auto;
  align-items: center;
}

.contact {
  padding-left: 1em;
  margin: 0.25em;
}
</style>
